//
//
//
//
//
//
//
//
//

import { VMask } from '../common';
import previewer from 'vue-photoswipe-mobile';
export default {
  name: 'seats-preview',
  components: {
    'v-mask': VMask
  },
  props: {
    src: {
      type: String,
      default: ''
    },
    mask: {
      type: Boolean,
      default: true
    }
  },
  computed: {},
  mounted: function mounted() {
    if (this.src) {
      previewer.open(0, [{
        type: 'image',
        src: this.src
      }], {
        loadingIndicatorDelay: 0,
        errorMsg: '<div class="pswp__error-msg" style="text-align: center;"><div style="width: 100vw;">图片加载失败</div></div>'
      });
    }
  },
  methods: {
    close: function close() {
      this.$emit('close');
    }
  }
};